<pw-tui-editor
  [config]="editorConfig"
  [required]="required"
  [disabled]="disabled"
  [ngModel]="getLocaleModel()"
  (ngModelChange)="onChangeCurrentValue($event)"
>
</pw-tui-editor>
